/**
 * The active view projection's diagnostics — the view's OWN health (unresolved
 * refs, sort mismatches, unknown policy/knob, or a projection crash). Published
 * by `LayoutProvider` (which already computes the plan for the board) and read by
 * the board-HUD health badge beside the view picker. Empty = the view is clean
 * (or no view is active), so the badge renders nothing.
 */
import { createContext, useContext } from "react";
import type { Diagnostic } from "@archlang/engine";

export const ViewPlanStatusContext = createContext<readonly Diagnostic[]>([]);

export const useViewPlanStatus = (): readonly Diagnostic[] => useContext(ViewPlanStatusContext);
